export function cn(...classes) {
  return classes
    .flatMap((cls) => {
      if (!cls) return [];
      if (typeof cls === "string") return cls.trim();
      if (Array.isArray(cls)) return cls;
      if (typeof cls === "object") {
        return Object.entries(cls)
          .filter(([, value]) => Boolean(value))
          .map(([key]) => key);
      }
      return String(cls).trim();
    })
    .filter(Boolean)
    .join(" ");
}


